'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propertyLabelTranslator = exports.propertyDescriptionTranslator = exports.tryYourTranslation = exports.tryLookup = exports.makeDescriptionKey = exports.makeNameSpacedKey = exports.convertToKey = exports.isInvalidString = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _getDescriptionHashKey = require('./internal/getDescriptionHashKey');

var _getDescriptionHashKey2 = _interopRequireDefault(_getDescriptionHashKey);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var re = /[\()\/\.\:\?\,\s\-\–\'&]/gi;

var nameSpaceKey = 'recordProperties';
var descriptionsNameSpaceKey = nameSpaceKey + '.propertyDescriptions';

var silentI18nText = function silentI18nText(key) {
  var temp = _I18n2.default.lookup(key);
  var translation = temp && typeof temp !== 'function' && _I18n2.default.text(key);
  return translation || undefined;
};
var tryLookup = function tryLookup(key, aString) {
  return silentI18nText(key) || aString;
};

var isInvalidString = function isInvalidString(maybeString) {
  return typeof maybeString !== 'string' || maybeString.length === 0;
};

var convertToKey = function convertToKey(aString) {
  return isInvalidString(aString) ? '' : aString.replace(re, '_').toLowerCase();
};

var makeNameSpacedKey = function makeNameSpacedKey(aString) {
  return nameSpaceKey + '.' + convertToKey(aString);
};
var makeDescriptionKey = function makeDescriptionKey(label, description) {
  return descriptionsNameSpaceKey + '.' + (0, _getDescriptionHashKey2.default)(description);
};

var tryYourTranslation = function tryYourTranslation(aString, optionalKeyPrefix) {
  var keyString = convertToKey(aString);
  if (!isInvalidString(optionalKeyPrefix)) {
    keyString = optionalKeyPrefix + '.' + keyString;
  }

  return tryLookup(keyString, aString);
};

var propertyLabelTranslator = function propertyLabelTranslator(label) {
  var nameSpaceLookupKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : nameSpaceKey;

  if (label && label === label.toUpperCase()) {
    return label;
  }

  return tryYourTranslation(label, nameSpaceLookupKey);
};

var propertyDescriptionTranslator = function propertyDescriptionTranslator(label, description) {
  if (isInvalidString(description) || _typeof(_I18n2.default.lookup(descriptionsNameSpaceKey)) !== 'object') {
    return description;
  }
  var descriptionKey = makeDescriptionKey(label, description);
  return tryLookup(descriptionKey, description);
};

exports.isInvalidString = isInvalidString;
exports.convertToKey = convertToKey;
exports.makeNameSpacedKey = makeNameSpacedKey;
exports.makeDescriptionKey = makeDescriptionKey;
exports.tryLookup = tryLookup;
exports.tryYourTranslation = tryYourTranslation;
exports.propertyDescriptionTranslator = propertyDescriptionTranslator;
exports.propertyLabelTranslator = propertyLabelTranslator;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/property-translator/static-1.251/js/propertyTranslator.js
// module id = 484
// module chunks = 0